import facebookIcon from '@/icons/facebook.svg';
import googleIcon from '@/icons/google.svg';
import instagramIcon from '@/icons/instagram.svg';
import linkedinIcon from '@/icons/linkedin.svg';
import tiktokIcon from '@/icons/tiktok.svg';
import yelpIcon from '@/icons/yelp.svg';
import youtubeIcon from '@/icons/youtube.svg';
import zillowIcon from '@/icons/zillow.svg';

export const reviewLinks = [
  {
    text: 'Zillow',
    href: 'https://www.zillow.com/reviews/search/?t=marshallreddick',
    icon: zillowIcon.src,
  },
  {
    text: 'Yelp',
    href: 'https://www.yelp.com/biz/marshall-reddick-real-estate-irvine',
    icon: yelpIcon.src,
  },
  { text: 'Google', href: 'https://g.page/r/CW6e3f5kHdMhEAE/review', icon: googleIcon.src },
];

export const socialLinks = [
  { text: 'YouTube', href: 'https://www.youtube.com/c/MarshallReddick', icon: youtubeIcon.src },
  {
    text: 'LinkedIn',
    href: 'https://www.linkedin.com/company/marshall-reddick-real-estate',
    icon: linkedinIcon.src,
    noreferrer: false,
  },
  {
    text: 'Facebook',
    href: 'https://www.facebook.com/marshallreddickrealestate',
    icon: facebookIcon.src,
  },
  {
    text: 'Instagram',
    href: 'https://www.instagram.com/marshallreddickrealestate',
    icon: instagramIcon.src,
  },
  { text: 'TikTok', href: 'https://www.tiktok.com/@marshallreddickre', icon: tiktokIcon.src },
];
